module.exports = __webpack_public_path__ + "static/media/p_15_4.0ce8ecbd.png";